import { render } from "./StyleMenuItem.vue?vue&type=template&id=56541864"
import script from "./StyleMenuItem.vue?vue&type=script&lang=js"
export * from "./StyleMenuItem.vue?vue&type=script&lang=js"

import "./StyleMenuItem.vue?vue&type=style&index=0&id=56541864&lang=css"

import exportComponent from "/Users/ricpp/Development/boldbrush/blog_post_editor/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__